import {useUpmPlant} from '@hconnect/upm'
import {DashboardCard, Loading} from '@hm/fundamental'

import {StaticPartDetailCardBody} from './StaticPartDetailCardBody'
import {EmptyComponent} from './StaticPartDetailCardBody/EmptyComponent'
import {StaticPartDetailCardHeader} from './StaticPartDetailCardHeader'

import {useShutdowns} from '@refra/modules/common/providers'
import {useStaticPartsTypeOptions} from '@refra/modules/refra-static-parts/hooks'
import {useStaticPartDetailQuery} from '@refra/modules/refra-static-parts/hooks/queries/useStaticPartDetailQuery'
import {SelectedComponentProvider} from '@refra/modules/refra-static-parts/providers'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const StaticPartDetailCard = () => {
  const staticPartId = useUrlParam('staticPartId')
  const plantCode = useUrlParam('plantCode')
  const selectedKilnId = useUrlParam('selectedKilnId')
  const upmPlant = useUpmPlant({plantId: plantCode})
  const {selectedShutdown} = useShutdowns()

  const {data: staticPart, isLoading: isStaticPartLoading} = useStaticPartDetailQuery({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKilnId,
    staticPartId: staticPartId,
    shutdownId: selectedShutdown?.id
  })

  const {getStaticPartComponents} = useStaticPartsTypeOptions()

  if (isStaticPartLoading) {
    return <Loading size="large" data-cy="static_part_detail_loader" />
  }

  if (!staticPart) {
    return (
      <DashboardCard>
        <EmptyComponent />
      </DashboardCard>
    )
  }

  const availableComponents = getStaticPartComponents(staticPart.type)

  return (
    <SelectedComponentProvider
      availableComponents={availableComponents}
      partComponents={staticPart.components}
    >
      <DashboardCard>
        <StaticPartDetailCardHeader staticPart={staticPart} />
        <StaticPartDetailCardBody />
      </DashboardCard>
    </SelectedComponentProvider>
  )
}
